/**
 * DashboardActivityOutput 类型和 Schema 定义
 *
 * ⚠️ 注意: 此文件由脚本自动生成，请勿手动修改
 * 如需更新，请运行代码生成脚本
 */
import type { SchemaDefinition } from './_schema'

/**
 * DashboardActivityOutput
 */
export interface DashboardActivityOutput {
  /** 活动ID */
  id?: string
  /** 员工ID */
  staff_id?: string
  /** 员工名称 */
  staff_name?: string
  /** 员工邮箱 */
  staff_email?: string
  /** 操作类型 */
  action?: string
  /** 目标类型 */
  target?: string
  /** 目标ID */
  target_id?: string
  /** 描述 */
  description?: string
  /** IP地址 */
  ip_address?: string
  /** 用户代理 */
  user_agent?: string
  /** 操作结果 */
  result?: string
  /** 额外信息 */
  extra?: string
  /** 创建时间（毫秒时间戳） */
  created_at?: number
}

/**
 * DashboardActivityOutput Schema
 */
export const DashboardActivityOutputSchema: SchemaDefinition = {
  properties: {
    id: {
      description: '活动ID',
      format: 'string',
      type: 'string',
      label: '活动ID',
    },
    staff_id: {
      description: '员工ID',
      format: 'string',
      type: 'string',
      label: '员工ID',
    },
    staff_name: {
      description: '员工名称',
      format: 'string',
      type: 'string',
      label: '员工名称',
    },
    staff_email: {
      description: '员工邮箱',
      format: 'string',
      type: 'string',
      label: '员工邮箱',
    },
    action: {
      description: '操作类型',
      format: 'string',
      type: 'string',
      label: '操作类型',
    },
    target: {
      description: '目标类型',
      format: 'string',
      type: 'string',
      label: '目标类型',
    },
    target_id: {
      description: '目标ID',
      format: 'string',
      type: 'string',
      label: '目标ID',
    },
    description: {
      description: '描述',
      format: 'string',
      type: 'string',
      label: '描述',
    },
    ip_address: {
      description: 'IP地址',
      format: 'string',
      type: 'string',
      label: 'IP地址',
    },
    user_agent: {
      description: '用户代理',
      format: 'string',
      type: 'string',
      label: '用户代理',
    },
    result: {
      description: '操作结果',
      format: 'string',
      type: 'string',
      label: '操作结果',
    },
    extra: {
      description: '额外信息',
      format: 'string',
      type: 'string',
      label: '额外信息',
    },
    created_at: {
      description: '创建时间（毫秒时间戳）',
      format: 'int64',
      type: 'integer',
      label: '创建时间',
    },
  },
  type: 'object',
}
